/*
 * @Author: Merlin
 * @Date: 2023-12-14 13:32:45
 * @LastEditors: Merlin
 * @LastEditTime: 2024-10-22 14:24:34
 * @Description: 
 */


// ↓弹出窗口 how it works 
const oHowItWorks = {
    'howTitle': {
        en: 'How it works?', 
        cn: '它是如何运行的？',
    },
    'close': {
        en: 'Close', 
        cn: '关闭', // 
    },
    's1Title01': {
        en: 'STEP 1',
        cn: '步骤 1',
    },
    's1Title02': {
        en: 'Choose currency',
        cn: '选择货币',
    },
    's1Desc': {
        en: 'It is important to choose a currency that aligns with your specific strategy and goals. Factors such as stability, and potential for growth should be taken into account when making this decision.',
        cn: '依据您的特定策略和目标选择相应货币是很重要的。稳定性和增长潜力等因素皆应该在您做决定时被考量。',
    },
    's2Title01': {
        en: 'STEP 2',
        cn: '步骤 2',
    },
    's2Title02': {
        en: 'Bet on the price going up or down',
        cn: '押注价格上涨或下跌',
    },
    's2Desc': {
        en: 'Predicting the future price of a cryptocurrency requires a detailed analysis of things like how people feel about the market, technological changes, and global events.',
        cn: '预测加密货币未来走势需要详细分析诸如市场情绪、技术分析与全球性事件。',
    },
    's3Title01': {
        en: 'STEP 3',
        cn: '步骤 3',
    },
    's3Title02': {
        en: 'Take your profit!',
        cn: '获利了结！',
    },
    's3Desc': {
        en: 'Secure earnings in the volatile market by taking profits when your bet reaches a favorable level. This proactive strategy ensures you benefit from positive changes.',
        cn: '当您的押注达到有利水平时通过止盈能够保障您在动荡市场当中获利。这种积极主动的策略可确保您从积极的变化中受益。',
    },
};


// ↓公平性窗口 
const oFairness = {
    'fairnessTitleOnHeader': {
        en: 'Fairness', 
        cn: '可证明公平性',
    },
    'fairDesc01': {
        en: 'The prices for the 24-hour round have been set beforehand using a randomly chosen seed, which will be revealed at the end of each trading round. With this seed made public, anyone can confirm that we followed the described algorithm and did not change any prices after trading began for the round. Importantly, we cannot adjust prices based on user bets.',
        cn: '24 小时回合的价格已使用随机选择的种子预先设定，该价格将在每个交易回合结束时公布。随着这个种子的公开，任何人都可以确认我们遵循了所描述的算法，并且在本轮交易开始后没有改变任何价格。重要的是，我们不能根据用户的押注调整价格。',
    },
    // 
    'fairnessTitleInside': {
        en: 'Previous rounds history', 
        cn: '过去回合历史',
    },
    // ----------------- 分界 -----------------
    'fiarPart01Title':{
        en: 'Algorithm',
        cn: '算法',
    },
    'fiarPart01Desc01':{
        en: 'At the start of each trading round, which begins at 00:00 UTC, a new 32-byte seed is chosen randomly. All prices for the round can be recreated by combining this seed with a tick counter that starts from zero and increases.',
        cn: '在每回合交易开始时（世界标准时间 00:00），随机选择一个新的 32 字节种子。通过将此种子与从零开始并增加的刻度计数器相结合，可以重新创建该回合的所有价格。',
    },
    'fiarPart01Desc02':{
        en: 'The seed is first transformed into a 64-character lowercase hexadecimal string, and then it is joined with the current value of the tick counter, represented as a string. Next, a hash of this combined string is computed using the SHA-256 hash function, producing a 256-bit digest. By utilizing a cryptographic hash function, we ensure that price alterations are random and unforeseeable until the seed is disclosed. However, once the seed is known, these changes can be completely replicated.',
        cn: '种子首先转换为 64 个字符的小写十六进制字符串，然后与刻度计数器的当前值连接，表示为字符串。接下来，使用 SHA-256 哈希函数计算该组合字符串的哈希值，生成 256 位摘要。通过利用加密哈希函数，我们确保价格变化是随机的且不可预见的，直到种子被公开。然而，一旦知道了种子，这些变化就可以完全复制。',
    },
    'fiarPart01Desc03':{
        en: `The first 8 bytes of the hash are converted into an unsigned 64-bit integer, assuming a little-endian encoding. This integer is then converted into a floating-point number within the range of 0 to 1, which follows a uniform distribution. Employing the inverse cumulative distribution function with the market's set tick volatility (0.1% standard deviation), we further transform this floating-point value into a return that adheres to a normal distribution. This return is then utilized to update the market's price.`,
        cn: '假设采用小端编码，哈希值的前 8 个字节将转换为无符号 64 位整数。然后将该整数转换为 0 到 1 范围内的浮点数，该浮点数遵循均匀分布。利用逆累积分布函数和市场设定的波动率（0.1％标准差），我们进一步将该浮点值转换为遵循正态分布的回报。然后利用该回报来更新市场价格。',
    },
    // ----------------- 分界 -----------------
    'fiarPart02Title':{
        en: 'Verification Example',
        cn: '验证示例',
    },
    'fiarPart02Desc01':{
        en: 'Anyone can confirm that the results of all previous game rounds were generated using a provably fair algorithm.',
        cn: '任何人都可以确认之前所有游戏回合的结果都是使用可证明公平的算法生成的。',
    },
    'fiarPart02Desc02':{
        en: 'Use any node js online playground, or check on your own desktop if you have an environment configured to work with Node.JS,',
        cn: '使用任何 Node js 在线测试环境，或者检查您自己的电脑是否有配置可使用 Node.JS 的环境，',
    },
    'fiarPart02Desc03':{
        en: 'Run the following script:',
        cn: '运行以下脚本：',
    },
    // ------------------------
    'fiarOutput':{
        en: 'The output is:',
        cn: '该结果是：', 
    },
};

// ↓ ROI 计算器窗口 
const oROI_Calulator = {
    'calc_roiTitle':{
        en: 'ROI Calculator',
        cn: 'ROI 计算器', 
    },
    'calc_EntryPrice': {
        en: 'Entry price',
        cn: '入场价格', 
    },
    'calc_Wager': {
        en: 'Wager',
        cn: '总押注', 
    },
    'calc_WagerAmount': {
        en: 'Wager',
        cn: '投注金额', 
    },
    'calc_PayoutMultiplier': {
        en: 'Payout multiplier',
        cn: '支付杠杆倍数', 
    },
    'calc_BustPrice': {
        en: 'Bust price',
        cn: '爆仓价格', 
    },
    'calc_Safe': {
        en: 'Safe',
        cn: '安全', 
    },
    'calc_Wild': {
        en: 'Wild',
        cn: '狂野', 
    },
    'calc_Up': {
        en: 'Up',
        cn: '做多', 
    },
    'calc_Down': {
        en: 'Down',
        cn: '做空', 
    },
    'calc_ExitPriceOptional': {
        en: 'Exit price (Optional)',
        cn: '出场价格（可选）',
    },
    'calc_desc01': {
        en: '*Calculator results are approximate and actual ROI/profit and loss may differ from those shown based on market conditions.',
        cn: '*计算器结果为近似值，实际投资回报率/损益可能与根据市场情况显示的结果有所不同。',
    },
    // ↓ 在原版被停用 
    'calc_desc02': {
        en: '*CorgiWaves commission is fixed - 5% of the profit, if any, is charged when the position is closed.',
        cn: '*CorgiWaves 佣金是固定的 - 平仓时将收取利润的 5%（如有）。',
    },
    // 左右分界 ==========================================
    'calc_PriceMove': {
        en: 'Price Move',
        cn: '价格变动', 
    },
    'calc_ExitPrice': {
        en: 'Exit Price',
        cn: '出场价格', 
    },
    'calc_PL_ROI': {
        en: 'P&L, ROI',
        cn: 'P&L, ROI', 
    },
};



// ↓ 顶部一排按钮相关的国际化信息 
const oTopBar = {
    'RoundEndsIn': {
        en: 'Round ends in', 
        cn: '回合结束于',
    },
    'ConfirmCashOut': {
        en: 'Confirm Cash Out', 
        cn: '确认提现',
    },
    'ConfirmAllCashOut': {
        en: 'Confirm All Cash Out', 
        cn: '确认全部提现',
    },
    'ProvablyFair': {
        en: 'Provably Fair', 
        cn: '可证明公平性',
    },
    'PriceFormulation': {
        en: 'Price Formulation', 
        cn: '价格组成',
    },
    'Funding': {
        en: 'Funding', 
        cn: '资金费率',
    },
    'hours24': {
        en: '24h', 
        cn: '24小时',
    },
    'CorgiWavesTips': {
        en: 'At 00:00 UTC price will reset to $1000 and all active positions on CorgiWaves will be closed.',
        cn: '于 00:00 UTC 时价格将重置为 $1000 且所有 CorgiWaves 的活跃仓位都将被平仓。',
    },
}


// ↓ 游戏面板区 
const oGamePanel = {
    'StartTrading': {
        en: 'Start Trading', 
        cn: '开始交易', 
    },
    // ---------------------------------------- 
    'LongTP': {
        en: 'Long TP/SL', 
        cn: '做多 止盈/止损',
    },
    'ShortTP': {
        en: 'Short TP/SL', 
        cn: '做空 止盈/止损 ',
    },
    // ---------------------------------------- 
    'YouDontPayAnyFeesTo': {
        en: `You don't pay any fees to open or close the trade with a PnL fee. Only a fraction of your profits (if any) is taken when you close the trade. Users receive 100% of their profits with a flat fee enabled. However, they prepay a flat fee that covers your entry, exit, and slippage before entering the trade, like on a regular exchange. The flat fee is calculated as a percentage of your position (wager * multiplier) Check ROI Calculator for more details`, 
        cn: '您无需支付任何费用即可开仓或平仓并以盈亏费用交易。您的部分利润（若有）将被收取于您关闭交易时。用户启用固定费用时可以获得 100% 的利润。然而，他们将需要在开仓时预付固定费用并包含您的入场、出场和滑点，如同在常规交易所一样。该固定费用=按您仓位的百分比计算（总押注 * 杠杆倍数）',
    },
    'PnLFee': {
        en: 'PnL Fee', 
        cn: '盈亏费用',
    },
    'FlatFee': {
        en: 'Flat Fee', 
        cn: '固定费用',
    },
    'PnLFeeTips': {
        en: 'A fraction of your profits (if any) is taken when you close the trade', 
        cn: '您的部分利润（若有）将被收取于您关闭该交易时', 
    },
    'FlatFeeTips': { 
        en: '{percent}% per entry and exit trades of {position} including slippage', 
        cn: '建仓与平仓各收取总额 {position} 的 {percent}% ，包含滑点', 
    },
    // ---------------------------------------- 
    'BFGDiscount': {
        en: 'BFG Discount', 
        cn: 'BFG 折扣', 
    },
    'SaveUpTo': {
        en: 'Save up to', 
        cn: '节省高达', 
    },
    'DiscountTips': {
        en: 'Your discount is calculated based on the USD value of your BFG holdings at the time of the trade:',
        cn: '您的折扣计算自您在交易时持有的 BFG 的美元价值：', 
    },
}


// ↓ 止盈止损设定专区（主要用于弹出窗口中）  
const oPnlControl = {
    // ---- ↓ 窗口02，设定止盈止损的窗口 --------------
    settingDialogTitle: {
        en: 'TP/SL for entire position',
        cn: '整个仓位的止盈/止损',
    },
    settingDialogFooterButton: {
        en: 'Confirm',
        cn: '确认', 
    },
    'Price': {
        en: 'Price', 
        cn: '价格', 
    },
    // ---- ↑ 窗口与其它位置专用  ----- 
    'TakeProfitAt': {
        en: 'Take profit at price / Profit', 
        cn: '止盈按价格／赢利',
    },
    settingDialogTip4Profit: {
        en: 'Your bet will be closed to take your earnings when it reaches the set price or profit amount.',
        cn: '当达到设定的价格或营利金额时您的押注将被关闭以获利了结。', 
    },
    'Profit': {
        en: 'Profit', 
        cn: '盈利', 
    },
    'long_Tp_PriceLow': {
        en: 'Take profit price cannot be lower than current price', 
        cn: '止盈价格不能低于当前价格', 
    },
    'short_Tp_PriceHigh': {
        en: 'Take profit price cannot be higher than current price', 
        cn: '止盈价格不能高于当前价格', 
    },
    // ----------------------------------- 
    // -------- ↑ 盈亏分界 ↓ ------------------  
    // ----------------------------------- 
    'CloseBetAt': {
        en: 'Close bet at price / Loss', 
        cn: '止损按价格／亏损 ',
    },
    settingDialogTip4Loss: {
        en: 'Your bet will be closed to save your funds when it reaches the set price or loss amount.',
        cn: '当达到设定的价格或损失金额时您的押注将被关闭以节省您的资金。', 
    },
    'Loss': {
        en: 'Loss',
        cn: '损失',
    },
};


// ↓ 大表格中点击后弹出的窗口 
const oWavesDetail = {
    'ActiveBet': {
        en: 'Active Bet', 
        cn: '持有的押注',
    },
    'ClosedBet': {
        en: 'Closed Bet',
        cn: '关闭的押注',
    },
    'PublicBet': {
        en: 'Public Bet',
        cn: '公开的押注',
    },
    'Leaderboard': {
        en: 'Leaderboard',
        cn: '排行榜',
    },
    // ↑ 窗口标题 ------------------------------
    'Player': {
        en: 'Player',
        cn: '玩家',
    },
    'OpenDate': {
        en: 'Open Date',
        cn: '开仓日期',
    },
    'CloseDate': {
        en: 'Close Date',
        cn: '平仓日期',
    },
    'FeeType': {
        en: 'Fee type',
        cn: '费用类型',
    },
    // ↑ 上方方框内容 ------------------------------
    'Multiplier': {
        en: 'Multiplier',
        cn: '杠杆倍数',
    },
    'EntryPrice': {
        en: 'Entry Price',
        cn: '入场价格',
    },
    'BustPrice': {
        en: 'Bust price',
        cn: '爆仓价格',
    },
    'ExitPrice': {
        en: 'Exit Price',
        cn: '出场价格',
    },
    'TakePrice': {
        en: 'Take Price',
        cn: '止盈价格',
    },
    'TakeProfit': {
        en: 'Take Profit',
        cn: '止盈',
    },
    'StopPrice': {
        en: 'Stop Price',
        cn: '止损价格',
    },
    'StopLoss': {
        en: 'Stop Loss',
        cn: '止损',
    },
    'FundingH': {
        en: 'Funding/H',
        cn: '资金费率/每小时',
    },
    // ↓ 最后2项 ------------------------------
    'BetCurrency': {
        en: 'Bet Currency',
        cn: '押注货币',
    },
    'Status': { // 此项同时应用于表格列 
        en: 'Status',
        cn: '状态',
    },
};

// ↓ 游戏合约的状态 5 种，
const oWavesContractState = {  
    'active': {
        en: 'Open', // 白色
        cn: '活跃中',
    },
    'cashOutProcessing': {
        en: 'Cashing out',
        cn: '兑现中',
    },
    'cashed': {
        en: 'Cashed', // 绿（损失钱了也是绿色）
        cn: '已兑现',
    },
    'profit': {
        en: 'Profit',
        cn: '盈利', // 止盈触发了，显示为绿色
    },
    // ↓ 以下2项图标与颜色相同：图标✘，颜色灰，#93ACD3 = rgb(147, 172, 211) 
    'loss': { // 止损
        en: 'Loss',
        cn: '亏损', // 止损触发了，
    },
    'busted': {
        en: 'Busted', 
        cn: '已爆仓',
    },
};


// ↓ 价格生成的说明页专用 
const oFormulation = {
    'PriceFormulationTitle': { 
        en: 'Price Formulation', 
        cn: '价格组成', 
    },
    'ToEnsureTransparent': { 
        en: 'To ensure transparent and accurate pricing for trading games, BetCorgi utilizes a composite index price that is calculated every 500 milliseconds. This index is derived from real-time price feeds from the most liquid spot and derivative cryptocurrency exchanges globally. By aggregating data from multiple sources, the BetCorgi index remains resilient to market manipulation, technical disruptions, and other irregular trading behavior that may arise on individual exchanges.', 
        cn: '为确保透明性与准确定价于交易游戏当中，BetCorgi 使用每 500 毫秒计算一次的综合指数价格。该指数来自全球流动性最强的现货和衍生加密货币交易所的实时价格馈送。通过汇总来自多个来源的数据，BetCorgi 指数对个别交易所可能出现的市场操纵、技术中断和其他不规则交易行为具有弹性。', 
    },
    'ThisApproachEnables': { 
        en: 'This approach enables BetCorgi to provide fair and reliable pricing to its users, fostering a trustworthy and secure trading environment.', 
        cn: '这种方法使 BetCorgi 能够提供公平可靠的价格给其用户，从而营造一个值得信赖和安全的交易环境。', 
    },
    'TheCalculationSteps': {
        en: 'The calculation steps are as follows:', 
        cn: '该计算步骤如下：',
    },
    // ---------------------------------------------------------------------
    'steps1': {
        en: `Subscribe to as many levels of depth as available using each exchange's streaming APIs.`, 
        cn: '订阅尽可能多的交易深度通过使用各交易所 API',
    },
    'steps2': {
        en: 'Remove any price feeds for which there have been no market data updates for the last 30 seconds', 
        cn: '去除任何价格馈送若过去 30 秒内没有市场数据更新',
    },
    'steps3': {
        en: 'Remove any price feeds with crossed buy and sell prices or whose top-of-book mid-price is more than 10% away from the median top-of-book mid-price across all price feeds.', 
        cn: '去除任何价格信息中买入价格和卖出价格交叉的报价或账面顶部中间价与账面顶部中间价中位数相差 10% 以上的任何价格信息。',
    },
    'steps4': {
        en: 'Wait until there are at least 6 valid price feeds. If there are not enough price feeds, the BetCorgi index price will not be updated.', 
        cn: '等到至少有 6 个有效的价格源。如果没有足够的喂价，BetCorgi 指数价格将不会更新。',
    },
    'steps5': {
        en: 'Combine all resting limit orders from each price feed into a single composite order book. It is okay and expected that the price of some buy orders will exceed the price of some sell orders from other exchanges. Individual order sizes are capped to $1 million to limit the influence of a single large order.', 
        cn: '将每个价格馈送中的全部剩余限价订单合并到一个复合订单簿中。可以预期一些买单的价格会超过其他交易所的一些卖单的价格。单个订单规模上限为 100 万美元，以限制单个大订单的影响。',
    },
    'steps6_1': {
        en: 'Using the composite order book, a function is defined to represent the marginal price to buy or sell a given amount. For example, the marginal buying function is: ', 
        cn: '使用复合订单簿，定义一个函数来表示买入或卖出给定金额的边际价格。例如，边际购买函数为：',
    },
    // ↓ 多种语言下的内容是一致的，而且下方内容会导致报错，把这段注释了（直接写到目标位置了） 
    // 'steps6_2': {
    //     // P_buy(s) = max{ґp_i | sum_{i in 1..N}{s_i} &lt;= s} // 转译后 
    //     en: `P_buy(s) = max{ґp_i | sum_{i in 1..N}{s_i} <= s}`, 
    //     cn: `P_buy(s) = max{ґp_i | sum_{i in 1..N}{s_i} <= s}`,
    // },
    'steps6_3': {
        en: ' where ', 
        cn: ' 当 ',
    },
    'steps6_4': {
        en: 'p_i | i in 1..N ', 
        cn: 'p_i | i in 1..N ',
    },
    'steps6_5': {
        en: ' and ', 
        cn: ' 和 ',
    },
    'steps6_6': {
        en: 's_i | i in 1..N', 
        cn: 's_i | i in 1..N',
    },
    'steps6_7': {
        en: ' are the buy prices and sizes sorted in increasing distance from the top-of-book. This function gives the maximum price one would pay to buy an amount s.', 
        cn: ' 购买价格和大小是否与订单顶部的距离越来越远。此功能给出了购买额 s 所支付的最高价格。',
    },
    'steps7_1': {
        en: 'The marginal buy and sell price functions are then used to define a marginal mid-price function given a size:', 
        cn: '该边际买入价和卖出价函数用于定义边际中间价函数予给定的大小：',
    },
    'steps7_2': {
        en: 'P_mid(s) = (P_buy(s) + P_sell(s)) / 2', 
        cn: 'P_mid(s) = (P_buy(s) + P_sell(s)) / 2',
    },
    'steps8_1': {
        en: 'The final index price is then calculated as the weighted average of the marginal mid-prices at each size. The weights are chosen to be the probability density of the exponential distribution, which is monotonically decreasing, resulting in a higher emphasis on prices closer to the top-of-book. The weights are given by:', 
        cn: '然后，将最终指数价格计算为每种规模的边际中间价格的加权平均值。权重被选为指数分布的概率密度，该指数分布单一递减，导致对更接近账面顶部的价格更加重视。权重由下式给出：',
    },
    'steps8_2': {
        en: 'w_i = L * exp(-L * v_i)',
        cn: 'w_i = L * exp(-L * v_i)',
    },
    // -- ↓ 1-8步说明内容下方的文字段落 ↓ -------------------------------------------------------------------
    'calculation_desc1_1': {
        en: 'Where ', 
        cn: '其中',
    },
    'calculation_desc1_2': {
        en: 'v_i', 
        cn: 'v_i',
    },
    'calculation_desc1_3': {
        en: ' are the sizes at which the mid-prices are calculated and are defined as the union of the cumulative buy and sell sizes from the composite order book. ', 
        cn: ' 是计算中间价的规模，定义为复合订单簿中累积买入和卖出规模的并集。',
    },
    'calculation_desc1_4': {
        en: 'L', 
        cn: 'L',
    },
    'calculation_desc1_5': {
        en: ' is a scaling factor defined as ', 
        cn: ' 是定义为 ',
    },
    'calculation_desc1_6': {
        en: '1 / V', 
        cn: '1 / V',
    },
    'calculation_desc1_7': { 
        en: ', where V is the maximum size at which a mid-price is calculated and is defined as the minimum of the sum of buying and selling sizes in the composite order book.', 
        cn: ' 的比例因子，其中 V 是计算中间价的最大大小，定义为复合订单簿中买入和卖出大小之和的最小值。',
    },
    'calculation_desc2': {
        en: 'The output of this calculation is a single index price that is used for both long and short bets in the BetCorgi trading game. Unlike with most other trading platforms, BetCorgi does not charge a bid-offer spread. Trading with a single price makes it possible to speculate on short-term price moves for which a bid-offer spread would be prohibitively expensive.',  
        cn: '此计算的输出是用于 BetCorgi 交易游戏中的多头和空头投注的单一指数价格。与大多数其他交易平台不同，BetCorgi 不收取买卖价差。使用单一价格进行交易可以对短期价格走势进行投机，而短期价格走势的买卖价差将极其昂贵。', 
    },
    // ---------------------------------------------------------------------
    'liquidationTitle': {
        en: 'Liquidation and Stop-Loss Price', 
        cn: '强制平仓和止损价格',
    },
    'liquidation_desc1': {
        en: 'Regardless of liquidity on underlying markets, we guarantee that take-profit and stop-loss orders will be executed at the price predetermined upon entry. The liquidation amount is limited to the initial bet amount, and stop-loss orders are limited by user settings.',
        cn: '无论基本市场的流动性如何，我们保证止盈和止损订单将以入场时预定的价格执行。强制平仓数量限制为初始押注数量，止损订单受用户设置限制。',
    },
    'liquidation_desc2_1': {
        en: 'Initial prices for liquidation and stop-loss can be calculated using:', 
        cn: '清算和止损的初始价格可以使用以下方法计算：',
    },
    'liquidation_desc2_2': {
        en: 'P_trigger = P_close * (1 + trade_sign*risk_buffer)', 
        cn: 'P_trigger = P_close * (1 + trade_sign*risk_buffer)',
    },
    'liquidation_desc2_3': {
        en: 'where P_close is the liquidation or stop-loss price of P_open*(1 - 1/bet_multiplier). risk_buffer is a set of parameters based on current market conditions. Its current value can be found here.', 
        cn: '其中P_close 是P_open*（1 - 1/bet_multiplier ） 的清算或止损价格。 risk_buffer 是基于当前市场状况的一组参数。它的当前值可以在这里找到。',
    },
    // ---------------------------------------------------------------------
    'MarketTitle': {
        en: 'Market Impact Effect', 
        cn: '市场影响效果',
    },
    'MarketTitle1': {
        en: 'The market impact effect is needed for calculating ROI and PNL fee.When trading on a traditional exchange with a central order book, large taker orders typically cross with maker orders outside the best bid or ask price, resulting in the average execution price being lower than the top-of-the-book price. Market makers limit the amount of liquidity they are willing to provide at the top of the book due to the additional risk posed by large orders.', 
        cn: '该市场影响效应需要用于计算 ROI 和 PNL 费用。当在具有中央订单簿的传统交易所交易时，大额接单通常会与最佳买入价或卖出价之外的挂单交叉并导致平均执行价格低于账面顶部价格。做市商限制了他们愿意在账面顶部提供的流动性量以应对大额订单带来的额外风险。',
    },
    'MarketTitle2': {
        en: 'Instead of requiring the execution of large stakes at multiple prices, BF instead uses a market impact formula to establish a closing price for profitable trades (losing trades closed manually do not affect it) to replicate the market impact of large stakes, but in a more consistent and predictable manner. The simplest way to see the exact market impact effect is to use an investment profitability calculator, which can be found on the futures trading page.', 
        cn: 'BF不需要以多个价格执行大额押注，而是使用市场影响公式来建立盈利交易的收盘价（手动关闭的亏损交易不会影响它）以在复制大额押注市场影响的同时以更一致和可预测的方式。查看确切市场影响的最简单方法是使用投资盈利能力计算器，该计算器可在期货交易页面上找到。',
    },
    'MarketTitle3': {
        en: 'Users can also calculate the closing price for profitable trades opened at a certain time and closed at a certain time using the formula: tT', 
        cn: '用户也可以计算特定期间内开仓和在特定期间内平仓的盈利交易收盘价通过使用以下公式：tT',
    },
    'MarketTitle_formula': {
        en: 'P_close(T) = P(t) + ((1 - base_rate) / (1 + 1/abs((P(T)/P(t) - 1)*rate_multiplier)^rate_exponent + bet_amount*bet_multiplier/(10^6*abs(P(T)/P(t) - 1)*position_multiplier)))*(P(T) - P(t))', 
        cn: 'P_close(T) = P(t) + ((1 - base_rate) / (1 + 1/abs((P(T)/P(t) - 1)*rate_multiplier)^rate_exponent + bet_amount*bet_multiplier/(10^6*abs(P(T)/P(t) - 1)*position_multiplier)))*(P(T) - P(t))',
    },
    'MarketTitle_last': {
        en: 'The parameters of the formula are set based on current market conditions, and their current values can be found here.', 
        cn: '公式的参数是根据当前市场情况设置的，它们的当前值可以在这里找到。',
    },
    // -------------------------------
    'ToFutures':{
        en: 'To Futures', 
        cn: '前往加密货币期货', 
    },
    'Back':{
        en: 'Back', 
        cn: '返回', 
    },
};

/*
    ↓ 12种错误速览 
    futures.errors.profitLow ● 盈利额不能小于 P&L
    futures.errors.profitNegative ● 盈利额不能小于零
    futures.errors.profitPriceHigh ● 止盈价格不能高于当前价格
    futures.errors.profitPriceLow ● 止盈价格不能低于当前价格
    --- ↓ loss ---- 
    futures.errors.lossHigherBet ● 止损价格太过接近当前价格
    futures.errors.lossPriceBust ● 止损价格不能超过爆仓价格
    futures.errors.lossPriceHigh ● 止损价格不能高于当前价格
    futures.errors.lossPriceLow ● 止损价格不能低于当前价格
    --- ↓ others ---- 
    futures.errors.emptyWager ● 押注数量为空白
    futures.errors.insufficientBalance ● 所选货币余额不足
    futures.errors.outOfPositionLimit ● 合計持仓量已达上限
    futures.errors.takeProfitNegative ● 止盈价格不能小于零
*/

// ↓ 共 12 种错误提示  
const enteringWrongValue = {
    // === ↓ 止盈管理 ====================
    'futures.errors.profitLow': {
        en: `The amount of profit can't be less than P&L`,
        cn: '盈利额不能小于 P&L',
    },
    'futures.errors.profitNegative': {
        en: 'The amount of the profit cannot be less than zero',
        cn: '盈利额不能小于零',
    },
    'futures.errors.profitPriceHigh': {
        en: 'Take profit price cannot be higher than current price',
        cn: '止盈价格不能高于当前价格',
    },
    'futures.errors.profitPriceLow': {
        en: 'Take profit price cannot be lower than current price',
        cn: '止盈价格不能低于当前价格',
    },
    'futures.errors.takeProfitNegative': {
        en: 'Take profit price cannot be less than zero',
        cn: '止盈价格不能小于零',
    },
    'futures.errors.profitPrice1': {
        en: 'The take-profit price cannot be lower than the stop-loss price.',
        cn: '止盈价格不能小于止损价格',
    },
    // === ↑ 止盈管理 ====================
    // === ↓ 止损管理 ====================
    'futures.errors.lossHigherBet': {
        en: 'Stop loss price is too close to current price',
        cn: '止损价格太过接近当前价格', // 原版中文不准，原版： 止损价格太过接近爆仓价格
    },
    'futures.errors.lossPriceBust': {
        en: 'Stop loss price can not be through bust price',
        cn: '止损价格不能超过爆仓价格',
    },
    'futures.errors.lossPriceLow': {
        en: 'Stop loss price cannot be lower than current price',
        cn: '止损价格不能低于当前价格',
    },
    'futures.errors.lossPriceHigh': {
        en: 'Stop loss price cannot be higher than current price', // 原版英文内容恰当
        cn: '止损价格不能高于当前价格', // 原版中文不准，原版： 止盈价格不能高于当前价格
    },
    // === ↓ 其它 ===========================
    'futures.errors.emptyWager': {
        en: 'The wager amount is empty',
        cn: '押注数量为空白',
    },
    'futures.errors.insufficientBalance': {
        en: 'Insufficient balance of selected currency',
        cn: '所选货币余额不足',
    },
    'futures.errors.outOfPositionLimit': {
        en: 'Total position amount limit reached',
        cn: '合计持仓量已达上限',
    },
    // ↓ 这是最后追加的，用于止赢止损窗口
    'futures.errors.hasClosed': {
        en: 'Cannot be modified. The current contract status has changed to: ',
        cn: '无法修改。当前合约状态已经变为：',
    },
    'futures.errors.lossPrice1': {
        en: 'The stop-loss price must not be lower than the take-profit price.',
        cn: '止损价格不能小于止盈价格',
    },
};

// ↓ 弹出窗口内的提示信息（手工平仓的确认信息） 
const oDialog = {  
    "closeOneTitle": {  
        // Modals.ConfirmCashOut.single.title
        en: 'Want to cash out?', 
        cn: '想要兑现吗？', 
    },
    "closeOne": {
        // Modals.ConfirmCashOut.single.description 
        en: 'By confirming the cash out, you close the position by the market price.', 
        cn: '通过确认兑现，您将以市场价格关闭当前仓位。', 
    },
    // --------- ↑ 平仓一项 ------------------ 
    // --------- ↓ 平仓全部合约 ------------------ 
    "closeAllTitle": {  
        // Modals.ConfirmCashOut.all.title
        en: 'Want to cash out all?', 
        cn: '想要兑现全部吗？', 
    },
    "closeAll": {  
        // Modals.ConfirmCashOut.all.description 
        en: 'By confirming the cash out, you close all positions by the market price. ', 
        cn: '通过确认兑现，您将以市场价格关闭全部仓位。', 
    },
    // ---- ↓ 其它 ---------------- 
    "DoNotShow": { 
        // Modals.ConfirmCashOut.dontShowAgain 
        en: 'Don’t show this again', 
        cn: '不再显示这个', 
    },
}; 

// ↓ 按钮相关 
const oButton = {
    'CashOut': { // 大表按钮
        en: 'Cash out', 
        cn: '兑现',
    },
    'AllCashOut': { // 大表上方按钮 
        en: 'All cash out', 
        cn: '全部兑现',
    },
    'Cancel': { // 用于确认窗口 
        en: 'Cancel', 
        cn: '取消',
    },
    'Up': {
        en: 'Up', 
        cn: '上涨',
    },
    'Down': {
        en: 'Down', 
        cn: '下跌', 
    },
    'StartEarning': {
        en: 'Start Earning', 
        cn: '开始赚币', 
    },
};

// ↓ 弹出消息，气泡提示等  
const oNotification = {
    Or01: {
        // 无数据提示
        en: 'or',
        cn: '或',
    },
    Or02: {
        // 无数据提示
        en: 'to see results',
        cn: '以查看结果',
    },
    created: {
        // futures.success.created
        en: 'Bet successfully created',
        cn: '投注成功创建',
    },
    // TODO 止盈价格错误，止损价格错误（后端发来的提示）
    // futures.tradingController.maxWager
    // futures.tradingController.minWager
    maxWager: {
        en: 'ℹ️ Max bet with current multiplier ●',
        cn: 'ℹ️ 最大押注是 ●',
    },
    minWager: {
        en: 'ℹ️ Min bet with current multiplier ●',
        cn: 'ℹ️ 最小押注是 ●',
    },
    tipsOnWinLose: {
        en: 'Set Take Profit / Stop Loss prices',
        cn: '设定止盈/止损价格',
    },
    tipsOnWin: {
        en: 'Take profit at price / Profit',
        cn: '止盈按价格／盈利',
    },
    tipsOnLose: {
        en: 'Take Profit / Stop Loss',
        cn: '止损按价格／亏损',
    },
    notExist: {
        en: 'The currency does not exist',
        cn: '该币种不存在!',
    },
};


export const oWavesGame = {
    ...oDialog, 
    ...oGamePanel, 
    ...oHowItWorks,
    ...oFairness, 
    ...oROI_Calulator, 
    ...oTopBar, 
    ...oButton,
    ...oWavesDetail, 
    ...oFormulation, 
    ...oPnlControl, 
    ...enteringWrongValue, 
    ...oWavesContractState, 
    ...oNotification, 
    'navLabel': { // 用于导航栏的标题
        en: 'Bet and Earn', 
        cn: '立即押注 & 赚币',
    },
    'gameCardTips': {
        en: 'Make a prediction on the price change determined by the randomizer and win more with high price volatility.', 
        cn: '预测随机生成变化的确定价格，并赢得更多通过高价格波动', 
    },
    'Bet': { // 大表格的 "币种" 列 
        en: 'Bet', 
        cn: '押注',
    },
    'Place': { // 大表格的 "排名" 列 
        en: 'Place', 
        cn: '排名',
    },
    'BetDetails': { // 大表格的最后一列  
        en: 'Bet Details', 
        cn: '押注详情',
    },
    'ResetTo': { // 图表的归零标记  
        en: 'Reset to', 
        cn: '重置为',
    },
    'AllInstruments': { // 币种下拉菜单 
        en: 'All coins', 
        cn: '所有币种',
    },
};



